<template>
  <v-layout>
    <text-dialog
      v-if="isTextDialogOpen"
      :isTextDialogOpen="isTextDialogOpen"
      :type="typeTextDialog"
      :title="title"
      :lottieUrl="lottieUrl"
      :explanation="explanation || explanationDefault"
      :details="details || detailsDefault"
      :cancelButtonText="cancelButtonText || cancelButtonTextDefault"
      :confirmButtonText="confirmButtonText || confirmButtonTextDefault"
      :confirmButtonColor="confirmButtonColor"
      @confirm="sendCreditRequest()"
      @cancel="closeDialog()"
    >
    </text-dialog>
    <text-dialog
      v-if="openConfirmDialog"
      :isTextDialogOpen="openConfirmDialog"
      :type="confirmDialog.typeTextDialog"
      :title="confirmDialog.title"
      :lottieUrl="confirmDialog.lottieUrl"
      :explanation="confirmDialog.explanation"
      :confirmButtonText="confirmDialog.confirmButtonText"
      :confirmButtonColor="confirmButtonColor"
      :cancelIsPossible="false"
      @confirm="confirm()"
    >
    </text-dialog>
  </v-layout>
</template>

<script>
import TextDialog from './TextDialog';

export default {
  name: 'creditDialog',
  components: {
    TextDialog,
  },
  props: {
    typeTextDialog: {
      type: String,
      default: null,
    },
    isTextDialogOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    explanation: {
      type: String,
      default: null,
    },
    details: {
      type: String,
      default: null,
    },
    cancelButtonText: {
      type: String,
      default: null,
    },
    confirmButtonText: {
      type: String,
      default: null,
    },
    lottieUrl: {
      type: String,
      default: 'images/rocket.json',
    },
  },
  data() {
    return {
      explanationDefault: this.$t('credits.dialog.explanation'),
      detailsDefault: this.$t('credits.dialog.details'),
      cancelButtonTextDefault: this.$t('credits.dialog.cancelButtonText'),
      confirmButtonTextDefault: this.$t('credits.dialog.confirmButtonText'),
      confirmButtonColor: 'yellow darken-2',
      openConfirmDialog: false,
      confirmDialog: {
        title: this.$t('credits.confirmDialog.title'),
        explanation: this.$t('credits.confirmDialog.explanation'),
        typeTextDialog: 'confirmCredit',
        lottieUrl: 'images/success.json',
        confirmButtonText: this.$t('credits.confirmDialog.confirmButtonText'),
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    currentAccountId() {
      return this.$store.getters['accounts/currentAccountId'];
    },
  },
  methods: {
    closeDialog() {
      this.$emit('cancel');
    },
    async confirm() {
      console.log('in confirm', this.typeTextDialog);
      this.openConfirmDialog = false;
      this.$emit('close-text-dialog');
    },
    async sendCreditRequest() {
      console.log('in request credit');
      const request = {
        controller: 'tracking',
        action: 'upgradeOffer',
        body: {
          firstname: this.currentUser.content.firstname,
          lastname: this.currentUser.content.lastname,
          email: this.currentUser.username,
          phone: this.currentUser.content.phone,
          account: this.currentAccount.name.fr,
        },
      };
      try {
        await this.$kuzzle.query(request);
        this.openConfirmDialog = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
  watch: {},
};
</script>

<style lang="sass"></style>
